// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"87dba840","703":"a1821286"}[chunkId] + ".chunk.js";
};